var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("details page "+_vm._s(this.$route.params.id))])
}
var staticRenderFns = []

export { render, staticRenderFns }